/**
 * THIS FILE IS AUTOGENERATED, DO NOT EDIT IT!
 *
 * See codegen config in .graphqlrc.yml for details
 */

/** Internal type. DO NOT USE DIRECTLY. */
type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
/** Internal type. DO NOT USE DIRECTLY. */
export type Incremental<T> =
  | T
  | { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
import { gql } from 'urql';
import * as Urql from 'urql';

import type * as Types from '@sg/graphql-schema';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type BagTimesPollingQueryVariables = Exact<{ [key: string]: never }>;

export type BagTimesPollingQuery = {
  readonly cart: {
    readonly __typename: 'Order';
    readonly id: string;
    readonly availableWantedTimes: ReadonlyArray<{
      readonly time: string;
      readonly deliveryOffset: number;
    }>;
  } | null;
};

export const BagTimesPollingDocument = gql`
  query BagTimesPolling {
    cart {
      id
      __typename
      availableWantedTimes {
        time
        deliveryOffset
      }
    }
  }
`;

export function useBagTimesPollingQuery(
  options?: Omit<Urql.UseQueryArgs<BagTimesPollingQueryVariables>, 'query'>,
) {
  return Urql.useQuery<BagTimesPollingQuery, BagTimesPollingQueryVariables>({
    query: BagTimesPollingDocument,
    ...options,
  });
}
